/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Form, Select } from "antd";
import { Title } from "./Common";
import { getApiHost } from "../../../utils";
import Axios from "axios";
import MapPropsContext from "../MapPropsContext";
import {
  TI_BROD_CH_COMBO_BOX,
  TI_BROD_CH_COMBO_BOX_DETAIL,
} from "../../../Constants";

function WidgetRadioBroad({ setServiceName, setRadioChannelData }) {
  const { widgetState } = useContext(MapPropsContext);
  const { broad_name_list } = widgetState;

  const [channelList, setChannelList] = useState([]);
  const [channel, setChannel] = useState(broad_name_list[1]);

  const onBroadChange = useCallback((name) => {
    setChannel();
    const url = getApiHost() + "/gis/radioServiceChannelList.json";
    const formData = new FormData();
    formData.append("broad_nm", encodeURI(name));

    Axios.post(url, formData)
      .then(({ data }) => {
        setChannelList(
          data.map(({ SERVICE_CD, SERVICE_NM }) => ({
            value: SERVICE_NM,
            label: SERVICE_NM,
          }))
        );
      })
      .catch((reason) => console.error(reason));
  }, []);

  const onChannelChange = useCallback((service_nm) => {
    const url = getApiHost() + "/gis/radioServiceChannelBottomList_NEW.json";
    const formData = new FormData();
    formData.append("service_nm", encodeURI(service_nm));
    setChannel(service_nm);
    Axios.post(url, formData)
      .then(({ data }) => {
        const { rows, legendList } = data;
        const originalChannelDict = rows;
        const channelDict = rows.reduce((acc, channel) => {
          const { SIG_CD } = channel;
          acc[SIG_CD] = channel;
          return acc;
        }, {});

        const colorDict = legendList.reduce((acc, channel) => {
          const { BROD_FREQ_NM } = channel;
          acc[BROD_FREQ_NM] = channel;
          return acc;
        }, {});

        setServiceName(service_nm);
        setRadioChannelData({ channelDict, colorDict, originalChannelDict });
      })
      .catch((reason) => console.error(reason));
  }, []);

  // 처음 렌더링 할 때, 초기값 "KBS - KBS Clasic FM" 으로 요청 보낸 후 셋팅
  useEffect(() => {
    onBroadChange(broad_name_list[0]);
    const url = getApiHost() + "/gis/radioServiceChannelBottomList_NEW.json";
    const formData = new FormData();
    formData.append("service_nm", encodeURI(broad_name_list[1]));
    setChannel(broad_name_list[1]);
    Axios.post(url, formData)
      .then(({ data }) => {
        const { rows, legendList } = data;
        const originalChannelDict = rows;
        const channelDict = rows.reduce((acc, channel) => {
          const { SIG_CD } = channel;
          acc[SIG_CD] = channel;
          return acc;
        }, {});

        const colorDict = legendList.reduce((acc, channel) => {
          const { BROD_FREQ_NM } = channel;
          acc[BROD_FREQ_NM] = channel;
          return acc;
        }, {});

        setServiceName(broad_name_list[1]);
        setRadioChannelData({ channelDict, colorDict, originalChannelDict });
      })
      .catch((reason) => console.error(reason));
  }, []);

  return (
    <Form.Item>
      <Title>방송사 채널 선택</Title>

      <Select
        aria-label="방송사 채널 선택"
        style={{ width: "100%" }}
        placeholder={"방송사"}
        defaultValue={broad_name_list[0]}
        onChange={onBroadChange}
        tabIndex={TI_BROD_CH_COMBO_BOX}
      >
        {OPTIONS.map((name) => (
          <Select.Option value={name} key={name}>
            {name}
          </Select.Option>
        ))}
      </Select>

      <Select
        aria-label="채널"
        style={{ width: "100%" }}
        placeholder={"채널"}
        onChange={onChannelChange}
        value={channel}
        tabIndex={TI_BROD_CH_COMBO_BOX_DETAIL}
      >
        {channelList.map(({ value, label }) => (
          <Select.Option value={value} key={value}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

const OPTIONS = [
  "KBS",
  "MBC",
  "SBS",
  "EBS",
  "CBS",
  "PBS",
  "BBS",
  "경인방송",
  "교통방송",
  "경기방송",
  "원음방송",
  "YTN",
  "아리랑국제방송",
  "국악방송",
  "극동방송",
  "영어방송",
  "국군방송",
  "글로벌광주방송",
  "소출력 FM",
];

export default WidgetRadioBroad;
